export default __webpack_public_path__ + "static/media/nflStaff14.ef98e2df.jpg";